import { ArrowLeft, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isElectron } from "@/lib/platform";

type PipWindowHeaderProps = {
	onClose?: () => void;
	onGoBack?: () => void;
};

export function PipWindowHeader({ onClose, onGoBack }: PipWindowHeaderProps) {
	if (!isElectron) {
		return null;
	}

	return (
		<div
			className="flex h-8 shrink-0 items-center justify-between bg-card px-1"
			style={{ WebkitAppRegion: "drag" } as React.CSSProperties}
		>
			<Button
				className="h-6 gap-1 px-2 text-xs"
				onClick={onGoBack}
				size="sm"
				style={{ WebkitAppRegion: "no-drag" } as React.CSSProperties}
				variant="ghost"
			>
				<ArrowLeft className="size-3" />
				Go back to call
			</Button>
			<Button
				className="size-6 p-0"
				onClick={onClose}
				size="icon"
				style={{ WebkitAppRegion: "no-drag" } as React.CSSProperties}
				variant="ghost"
			>
				<X className="size-3" />
			</Button>
		</div>
	);
}
